export default __webpack_public_path__ + "static/media/img-6.b42c392f.jpg";